// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"privacy-policy_privacyPolicy__DcG_U"};